import React, { useContext, useMemo, useState } from "react";
import { GameBoardContext } from "../../../../context/createContext";
import {
  InputBox,
  InputWrapper,
} from "./autoComponentsStyles/NumberOfBetsStyles";
import { ReactComponent as Infinity } from "../../../../lib/assets/icons/infinite.svg";

import {
  handleNumbersOfBetsChange,
  handleAutoNumberOfBetsBlur,
} from "../helpers/numberOfBetsInputValidation";
import { useTranslation } from "../../../../locale/context";

const NumberOfBets = ({
  autoPilotNumber,
  disabled,
}: {
  autoPilotNumber: string;
  disabled: boolean;
}) => {
  const { auto, funcs } = useContext(GameBoardContext);
  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      numberOfBetLabel: t("input.numberOfBetLabel"),
    };
  }, [t]);
  // const funcs = autoContext.funcs

  // const autoPilotInfo = Object.values(autoContext.auto)[
  //   autoPilotNumber === "first" ? 0 : 1
  // ]

  // const [autoNumberOfBets, setAutoNumberOfBets] = useState("0")
  const autoObj = autoPilotNumber === "first" ? auto.first : auto.second;
  const autoNumberOfBets = autoObj.numberOfBets;

  const [inputsFocus, setInputsFocus] = useState(false);

  const { handleAutoInputs } = funcs;

  const Focus = (e: any) => {
    e.target.placeholder = "";
    setInputsFocus(true);
    e.target.select();
  };

  const Blur = (key: string, value: string) => {
    handleAutoNumberOfBetsBlur(handleAutoInputs, autoPilotNumber, key, value);
    setInputsFocus(false);
  };

  const onNumberOfBetsChange = (e: any) =>
    handleNumbersOfBetsChange(e, handleAutoInputs, autoPilotNumber);

  return (
    <InputBox focus={inputsFocus}>
      <label>{languagePack.numberOfBetLabel}</label>
      <InputWrapper focus={inputsFocus} disabled={disabled}>
        <input
          value={
            autoNumberOfBets !== "0" && autoNumberOfBets !== ""
              ? autoNumberOfBets
              : ""
          }
          onFocus={(e: any) => !disabled && Focus(e)}
          onBlur={() => Blur("numberOfBets", autoNumberOfBets)}
          onChange={(e) => onNumberOfBetsChange(e)}
          maxLength={4}
        />
        {(autoNumberOfBets === "0" || autoNumberOfBets === "") && (
          <Infinity style={{ top: "5px" }} />
        )}
      </InputWrapper>
    </InputBox>
  );
};

export default NumberOfBets;
